import { render, staticRenderFns } from "./VineyardResourceGraphs.vue?vue&type=template&id=12b8a4fe&scoped=true&"
import script from "./VineyardResourceGraphs.vue?vue&type=script&lang=js&"
export * from "./VineyardResourceGraphs.vue?vue&type=script&lang=js&"
import style0 from "./VineyardResourceGraphs.vue?vue&type=style&index=0&id=12b8a4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8a4fe",
  null
  
)

export default component.exports